import {
  searchContacts,
  searchContracts,
  searchCrews,
  searchItems,
  searchProjects,
  searchUsers
} from "../api-helpers/api-search";

export default {
  state: {
    isSearchingContacts: false,
    searchedContacts: null,
    isSearchingContracts: false,
    searchedContracts: null,
    isSearchingCrews: false,
    searchedCrews: null,
    isSearchingItems: false,
    searchedItems: null,
    isSearchingProjects: false,
    searchedProjects: null,
    isSearchingUsers: false,
    searchedUsers: null,
    areSearchResultsShown: false,
    searchTerm: null
  },
  mutations: {
    setIsSearchingContacts(state, bool) {
      state.isSearchingContacts = bool;
    },
    setSearchedContacts(state, contacts) {
      state.searchedContacts = contacts;
    },
    setIsSearchingContracts(state, bool) {
      state.isSearchingContracts = bool;
    },
    setSearchedContracts(state, contacts) {
      state.searchedContracts = contacts;
    },
    setIsSearchingCrews(state, bool) {
      state.isSearchingCrews = bool;
    },
    setSearchedCrews(state, crews) {
      state.searchedCrews = crews;
    },
    setIsSearchingItems(state, bool) {
      state.isSearchingItems = bool;
    },
    setSearchedItems(state, items) {
      state.searchedItems = items;
    },
    setIsSearchingProjects(state, bool) {
      state.isSearchingProjects = bool;
    },
    setSearchedProjects(state, projects) {
      state.searchedProjects = projects;
    },
    setIsSearchingUsers(state, bool) {
      state.isSearchingUsers = bool;
    },
    setSearchedUsers(state, projects) {
      state.searchedUsers = projects;
    },
    setAreSearchResultsShown(state, bool) {
      state.areSearchResultsShown = bool;
    },
    setSearchTerm(state, text) {
      state.searchTerm = text;
    }
  },
  actions: {
    async searchContacts({ state, commit }, searchTerm) {
      let searchedContacts = state.searchedContacts;
      if (!state.isSearchingContacts) {
        commit("setIsSearchingContacts", true);
        commit("setAreSearchResultsShown", true);

        searchedContacts = await searchContacts(searchTerm);
        commit("setSearchedContacts", searchedContacts);
        commit("setSearchTerm", searchTerm);

        commit("setIsSearchingContacts", false);
      }
      return searchedContacts;
    },
    async searchContracts({ state, commit }, searchTerm) {
      let searchedContracts = state.searchedContracts;
      if (!state.isSearchingContracts) {
        commit("setIsSearchingContracts", true);
        commit("setAreSearchResultsShown", true);

        searchedContracts = await searchContracts(searchTerm);
        commit("setSearchedContracts", searchedContracts);
        commit("setSearchTerm", searchTerm);

        commit("setIsSearchingContracts", false);
      }
      return searchedContracts;
    },
    async searchCrews({ state, commit }, searchTerm) {
      let searchedCrews = state.searchedCrews;
      if (!state.isSearchingCrews) {
        commit("setIsSearchingCrews", true);
        commit("setAreSearchResultsShown", true);

        searchedCrews = await searchCrews(searchTerm);
        commit("setSearchedCrews", searchedCrews);
        commit("setSearchTerm", searchTerm);

        commit("setIsSearchingCrews", false);
      }
      return searchedCrews;
    },
    async searchItems({ state, commit }, searchTerm) {
      let searchedItems = state.searchedItems;
      if (!state.isSearchingItems) {
        commit("setIsSearchingItems", true);
        commit("setAreSearchResultsShown", true);

        searchedItems = await searchItems(searchTerm);
        commit("setSearchedItems", searchedItems);
        commit("setSearchTerm", searchTerm);

        commit("setIsSearchingItems", false);
      }
      return searchedItems;
    },
    async searchProjects({ state, commit }, searchTerm) {
      let searchedProjects = state.searchedProjects;
      if (!state.isSearchingProjects) {
        commit("setIsSearchingProjects", true);
        commit("setAreSearchResultsShown", true);

        searchedProjects = await searchProjects(searchTerm);
        commit("setSearchedProjects", searchedProjects);
        commit("setSearchTerm", searchTerm);

        commit("setIsSearchingProjects", false);
      }
      return searchedProjects;
    },
    async searchUsers({ state, commit }, searchTerm) {
      let searchedUsers = state.searchedUsers;
      if (!state.isSearchingUsers) {
        commit("setIsSearchingUsers", true);
        commit("setAreSearchResultsShown", true);

        searchedUsers = await searchUsers(searchTerm);
        commit("setSearchedUsers", searchedUsers);
        commit("setSearchTerm", searchTerm);

        commit("setIsSearchingUsers", false);
      }
      return searchedUsers;
    },
    async globalSearch({ dispatch }, searchTerm) {
      const contacts = await dispatch("searchContacts", searchTerm);
      const contracts = await dispatch("searchContracts", searchTerm);
      const projects = await dispatch("searchProjects", searchTerm);

      return {
        contacts,
        contracts,
        projects
      };
    }
  }
};
